import { ChangeEvent } from 'react';
import { Chip, Input, Text, Title } from '@nimbus-ds/components';
import { Stack } from 'commons/components';

interface GenericSelectionModalHeaderProps {
  title: string;
  description: string;
  totalItems: number;
  selectedCount: number;
  searchTerm: string;
  searchPlaceholder: string;
  counterText: string;
  minItemsForSearch: number;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClearSelection: () => void;
}

function GenericSelectionModalHeader({
  title,
  description,
  totalItems,
  selectedCount,
  searchTerm,
  searchPlaceholder,
  counterText,
  minItemsForSearch,
  onSearchChange,
  onClearSelection,
}: Readonly<GenericSelectionModalHeaderProps>): JSX.Element {
  return (
    <Stack column align="stretch" spacing="base" paddingX="4">
      <Stack.Item>
        <Title as="h2">{title}</Title>
      </Stack.Item>

      <Stack.Item>
        <Text color="neutral-textLow">{description}</Text>
      </Stack.Item>

      {totalItems >= minItemsForSearch && (
        <Stack.Item>
          <Input
            type="search"
            name="search"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={onSearchChange}
          />
        </Stack.Item>
      )}

      {selectedCount > 0 && (
        <Stack.Item>
          <Chip
            id="selectedItemsChip"
            text={counterText}
            removable
            onClick={onClearSelection}
          />
        </Stack.Item>
      )}
    </Stack>
  );
}

export default GenericSelectionModalHeader;
